import { render, staticRenderFns } from "./RankingPage.vue?vue&type=template&id=d996d1b8"
import script from "./RankingPage.vue?vue&type=script&lang=js"
export * from "./RankingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports